/**
 * Polyfill for Array.prototype.findLast
 *
 * This method was introduced in:
 * - Chrome 97+
 * - Firefox 104+
 * - Safari 15.4+
 *
 * This polyfill ensures compatibility with older browsers.
 */

if (!Array.prototype.findLast) {
  Object.defineProperty(Array.prototype, 'findLast', {
    configurable: true,
    writable: true,
    value: function <T>(
      this: T[],
      predicate: (value: T, index: number, array: T[]) => unknown,
      thisArg?: unknown,
    ): T | undefined {
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      for (let i = this.length - 1; i >= 0; i -= 1) {
        const v = this[i];

        if (predicate.call(thisArg, v, i, this)) {
          return v;
        }
      }

      return undefined;
    },
  });
}

export {};
